import { render } from "./RecordsView.vue?vue&type=template&id=538613fe&scoped=true"
import script from "./RecordsView.vue?vue&type=script&lang=js"
export * from "./RecordsView.vue?vue&type=script&lang=js"

import "./RecordsView.vue?vue&type=style&index=0&id=538613fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538613fe"]])

export default __exports__